import React, { useState } from 'react';
import { List, NavBar, Icon, Switch } from 'antd-mobile';
import { getBooleanValue, putBooleanValue } from '../../utils';
import { useHistory } from 'react-router';
const Item = List.Item;

function Setting() {
  const [audioSwitch, setAudio] = useState(
    getBooleanValue('AUTO_AUDIO', false, (value) => {
      setAudio(value);
    }),
  );
  const [videoSwitch, setVideo] = useState(
    getBooleanValue('AUTO_VIDEO', false, (value) => {
      setVideo(value);
    }),
  );
  const history = useHistory();
  return (
    <div>
      <NavBar
        mode="light"
        icon={<Icon type="left" />}
        onLeftClick={() => history.goBack()}
        style={
          getBooleanValue('IS_IMMERSE', false)
            ? { marginBottom: '5vw', paddingTop: '6vw', height: '18vw' }
            : { marginBottom: '5vw', height: '12vw' }
        }
      >
        设置
      </NavBar>
      <List>
        <Item
          extra={
            <Switch
              checked={audioSwitch}
              onChange={(checked) => {
                setAudio(checked);
                putBooleanValue('AUTO_AUDIO', checked);
              }}
              className="set-item"
            />
          }
        >
          入会是否自动开启音频
        </Item>
        <Item
          extra={
            <Switch
              checked={videoSwitch}
              onChange={(checked) => {
                setVideo(checked);
                putBooleanValue('AUTO_VIDEO', checked);
              }}
              className="set-item"
            />
          }
        >
          入会是否自动开启视频
        </Item>
      </List>
    </div>
  );
}

export default Setting;
